export const FORM_SUBMIT_BUTTON = 'form-submit-button';
export const INPUT_ERROR_MESSAGE = 'form-error-message';

export const DATA_TABLE_DATE_COLUMN = 'data-table-date-column';
export const OM_ONBOARDING = {
	ONBOARDING_HEADER: 'onboarding-header',
	KYC_START_BUTTON: 'kyc-start-btn',
	RESUBMIT_KYC_BUTTON: 'resubmit-kyc-btn',
	EMAIL_VERIFICATION: 'email-verification',
	VERIFY_EMAIL_BUTTON: 'verify-email-btn',
	EMAIL_ID_TEXT: 'email-id',
	KYC_SUBMITTED: 'kyc-submitted',
	ACTIVATE_PG_BUTTON: 'activate-pg-btn',
	FULLNAME_INPUT: 'fullname-input',
	DISPLAY_NAME_INPUT: 'display-name-input',
	SUPER_CATEGORY_SELECT: 'super-category-select',
	BUSINESS_DESCRIPTION_INPUT: 'business-desc-input',
	WEBSITE_URL_INPUT: 'website-url-input',
	INTERNAL_URL_INPUT: 'internal-url-input',
	ANDROID_APP_URL_INPUT: 'android-app-url-input',
	ANDROID_PACKAGE_NAME_INPUT: 'android-package-name-input',
	IOS_APP_URL_INPUT: 'ios-app-url-input',
	IOS_PACKAGE_NAME_INPUT: 'ios-package-name-input',
	WEB_CHECKBOX: 'web-checkbox',
	ANDROID_CHECKBOX: 'android-checkbox',
	IOS_CHECKBOX: 'ios-checkbox',
	WEBSITE_TNC_INPUT: 'website-tnc-input',
	ANDROID_TNC_INPUT: 'android-tnc-input',
	IOS_TNC_INPUT: 'ios-tnc-input',
	WEB_REFUND_URL_INPUT: 'website-refund-url-input',
	ANDROID_REFUND_URL_INPUT: 'android-refund-url-input',
	IOS_REFUND_URL_INPUT: 'ios-refund-url-input',
	WEB_SHIPPING_URL_INPUT: 'website-shipping-url-input',
	ANDROID_SHIPPING_URL_INPUT: 'android-shipping-url-input',
	IOS_SHIPPING_URL_INPUT: 'ios-shipping-url-input',
	WEB_PRIVACY_URL_INPUT: 'website-privacy-url-input',
	ANDROID_PRIVACY_URL_INPUT: 'android-privacy-url-input',
	IOS_PRIVACY_URL_INPUT: 'ios-privacy-url-input',
	IOS_NO_SHIPPING_CHECKBOX: 'ios-no-shipping-checkbox',
	ANDROID_NO_SHIPPING_CHECKBOX: 'android-no-shipping-checkbox',
	WEB_NO_SHIPPING_CHECKBOX: 'web-no-shipping-checkbox',
	TNC_CHECKBOX: 'tnc-checkbox',
	ACTIVATION_NEXT_BUTTON: 'activation-next-btn',
	ACTIVATION_PREVIOUS_BUTTON: 'activation-previous-btn',
	WEB_RETURN_URL_INPUT: 'website-return-url-input',
	ANDROID_RETURN_URL_INPUT: 'android-return-url-input',
	IOS_RETURN_URL_INPUT: 'ios-return-url-input',
	WEB_NO_RETURN_CHECKBOX: 'web-no-return-checkbox',
	ANDROID_NO_RETURN_CHECKBOX: 'android-no-return-checkbox',
	IOS_NO_RETURN_CHECKBOX: 'ios-no-return-checkbox',
	PRODUCT_INFO_EXPAND_ICON: 'activation-info-expand-icon',
	POLICY_FORM: 'policy-form',
};
